var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('section',[_c('topSection',{attrs:{"isSliderOn":true}})],1),_c('section',[_c('works')],1),_c('section',[_c('projects')],1),_c('section',[_c('contactUs')],1),_c('footerr',[_c('footer')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }